import script from "./SmHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./SmHeader.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__